import { combineReducers } from 'redux';
import bsdirResolverReducer from 'Douleutaras/redux/data/bsdir/bsdirResolverSlice';
import bsdirCategoriesReducer from 'Douleutaras/redux/data/bsdir/bsdirCategoriesSlice';
import bsdirFaqItemsReducer from 'Douleutaras/redux/data/bsdir/bsdirFaqItemsSlice';
import bsdirTopProsReducer from 'Douleutaras/redux/data/bsdir/bsdirTopProsSlice';
import bsdirFeedbacksReducer from 'Douleutaras/redux/data/bsdir/bsdirFeedbacksSlice';
import bsdirPricingReducer from 'Douleutaras/redux/data/bsdir/bsdirPricingSlice';
import bsdirSubCategoryPricingsReducer from 'Douleutaras/redux/data/bsdir/bsdirSubCategoryPricingsSlice';
import bsdirGalleriesReducer from 'Douleutaras/redux/data/bsdir/bsdirGalleriesSlice';
import bsdirGalleryItemsReducer from 'Douleutaras/redux/data/bsdir/bsdirGalleryItemsSlice';
import bsdirRelatedServicesReducer from 'Douleutaras/redux/data/bsdir/bsdirRelatedServicesSlice';
import bsdirLastConcludedJobsReducer from 'Douleutaras/redux/data/bsdir/bsdirLastConcludedJobsSlice';
import bsdirPageLinksReducer from 'Douleutaras/redux/data/bsdir/bsdirPageLinksSlice';
import bsdirLocationLinksReducer from 'Douleutaras/redux/data/bsdir/bsdirLocationLinksSlice';

export default combineReducers({
  resolver: bsdirResolverReducer,
  categories: bsdirCategoriesReducer,
  faqItems: bsdirFaqItemsReducer,
  topPros: bsdirTopProsReducer,
  feedbacks: bsdirFeedbacksReducer,
  pricing: bsdirPricingReducer,
  subCategoryPricings: bsdirSubCategoryPricingsReducer,
  galleries: bsdirGalleriesReducer,
  galleryItems: bsdirGalleryItemsReducer,
  relatedServices: bsdirRelatedServicesReducer,
  lastConcludedJobs: bsdirLastConcludedJobsReducer,
  pageLinks: bsdirPageLinksReducer,
  locationLinks: bsdirLocationLinksReducer
});
